// @ts-nocheck

import React, { memo, useContext } from "react";
import { FieldMessagesProps } from "./FieldMessage.props";
import cn from "classnames";
import { ErrorMessage } from "@hookform/error-message";

import styles from "./FieldMessage.module.scss";
import HelperText from "../HelperText";
import ErrorMessageComponent from "../ErrorMessage";
import { FormContext } from "../../Form";

/**
 * @deprecated
 */
const FieldMessages: React.FC<FieldMessagesProps> = (props: FieldMessagesProps): JSX.Element | null => {
  const { id, errors, helperText, name, isLoading = false, readOnly } = props;
  const fieldMessageClasses = cn(styles["field-messages-wrapper"]);
  const { readOnly: readOnlyForm } = useContext(FormContext);

  let helperTextComponent = null;
  if (helperText && !(errors && errors[name])) {
    helperTextComponent = <HelperText id={id} body={helperText} isLoading={isLoading} />;
  }

  if (!readOnly && !isLoading && !readOnlyForm) {
    return (
      <div id={`${id}-field-messages`} className={fieldMessageClasses}>
        {helperTextComponent}
        <ErrorMessage errors={errors || {}} name={name} render={() => <ErrorMessageComponent id={id} name={name} />} />
      </div>
    );
  }

  return null;
};

/**
 * @deprecated
 */
export default memo(FieldMessages);
